import Vue from 'vue'
import Router from 'vue-router'
import Signup from '@/components/User/Signup'
import Signin from '@/components/User/Signin'
import Profile from '@/components/User/Profile'
import About from '@/components/User/About'
import mapBoard from '@/components/toolBox/mapBoard'
import mB1 from '@/components/toolBox/mB1'
import mB2 from '@/components/toolBox/mB2'
import mB3 from '@/components/toolBox/mB3'
import schoolIndex from '@/components/toolBox/schoolIndex'
import selectorIndex from '@/components/toolBox/selectorIndex'
import poiIndex from '@/components/toolBox/poiIndex'
import pixelPicker from '@/components/toolBox/pixelPicker'
import basepicker from '@/components/toolBox/basepicker'
import timePicker from '@/components/toolBox/timePicker'
import typePicker from '@/components/toolBox/typePicker'
import inverter from '@/components/toolBox/inverter'
import cluster from '@/components/toolBox/cluster'
import complete from '@/components/order/complete'
import order from '@/components/order/order'
import product from '@/components/order/product'
import Home from '@/components/Home'
import Cutout from '@/components/Cutout/Cutout'
import Introduction from '@/components/User/Introduction/Introduction'
// import Introduction from '@/components/User/Introduction/Introduction'

// const Signup = () => import('@/components/User/Signup')
// onst Signin = () => import('@/components/User/Signin')
// const schoolIndex = () => import('@/components/toolBox/schoolIndex')
// const mapBoard = () => import('@/components/toolBox/mapBoard')

import AuthGuard from './auth-guard'
import idMb3 from './idMb3'
import idMboard from './idMboard'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/mB3',
      name: 'mB3',
      component: mB3,
      beforeEnter: AuthGuard
      // beforeRouteLeave: idMb3
    },
    {
      path: '/basepicker',
      name: 'basepicker',
      component: basepicker
    },
    {
      path: '/',
      name: 'mapBoard',
      component: mapBoard,
      beforeEnter: AuthGuard
    },
    {
      path: '/typepicker',
      name: 'typePicker',
      component: typePicker
    },
    {
      path: '/introduction',
      name: 'Introduction',
      component: Introduction
    },
    {
      path: '/mapboard',
      name: 'mapBoard',
      component: mapBoard,
      beforeEnter: AuthGuard
      // beforeRouteLeave: idMboard
      // beforeRouteEnter: DrawerOpen,
      // beforeRouteLeave: DrawerClose
    },
    {
      path: '/mb1',
      name: 'mB1',
      component: mB1
    },
    /*
    {
      path: '/fireui',
      name: 'fireui',
      component: fireui
    },
    */
    {
      path: '/cutouts/:id',
      name: 'Cutout',
      props: true,
      component: Cutout
    },
    {
      path: '/inverter',
      name: 'inverter',
      component: inverter
    },
    {
      path: '/selectorindex',
      name: 'selectorIndex',
      component: selectorIndex
    },
    {
      path: '/poiindex',
      name: 'poiIndex',
      component: poiIndex
    },
    {
      path: '/order',
      name: 'order',
      component: order
    },
    {
      path: '/complete',
      name: 'complete',
      component: complete
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/signin',
      name: 'Signin',
      component: Signin
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile
    },
    {
      path: '/schoolindex',
      name: 'schoolIndex',
      component: schoolIndex
    },
    {
      path: '/pixelpicker',
      name: 'pixelPicker',
      component: pixelPicker
    },
    {
      path: '/timepicker',
      name: 'timePicker',
      component: timePicker
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js